import moment, {Moment} from 'moment';

export function dateToStringDDMonYYYY(pDate: Moment) {
  return moment(pDate).format("D MMM YYYY");
}

export function humanReadableBytes(bytes:number):string {
  var i = Math.floor(Math.log(bytes) / Math.log(1024)),
    sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  // @ts-ignore
  return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + sizes[i];
}
